import React from 'react';
import propTypes from 'prop-types';
import parser from 'html-react-parser';
import domToReact from 'html-react-parser/lib/dom-to-react';

// @tcc
import { TooltipWrapper } from '@tcc/crate';
import { getMessage } from 'util/locale';

/* Valid for HTMLText that support only one tooltip per HTML string */
const HtmlTextWithTooltip = ({
  tooltip,
  messageKey
}) => {

  const parserOptions = {
    replace: (domNode) => {

      // Find the domNode where the tooltip needs to be attached and wrap it
      if (domNode.attribs && domNode.attribs.id === tooltip.triggerElementId) {
        return (
          <TooltipWrapper
            alignment={'ALIGNMENTS.CENTER'}
            className='vra-tooltip__inline-wrapper'
            content={[getMessage(tooltip.contentKey)]}
            title={getMessage(tooltip.titleKey)}
          >
            
            {/* Recreate the Element to keep its HTML markup   */}
            {domToReact([domNode])}

          </TooltipWrapper>
        );
      } else {
        return domNode;
      }
    }
  };

  return parser(getMessage(messageKey), parserOptions);
};
HtmlTextWithTooltip.propTypes = {
  messageKey: propTypes.string.isRequired, // ID of text to load from i18n (trusted resource)
  tooltip: propTypes.shape({
    triggerElementId: propTypes.string.isRequired, // Resource text defined by ^^^ messageKey should have an HTML element with matching ID.
    contentKey: propTypes.string.isRequired, // ID of text to appear within tooltip itself.
    titleKey: propTypes.string // ID of title to appear within tooltip itself.
  }).isRequired
};
export default HtmlTextWithTooltip;
